﻿import { get as getProjection, getPointResolution, METERS_PER_UNIT } from 'ol/proj';
import * as defaults from './defaults';
import * as paths from './paths';
import * as formats from './formats';
import { transformExtent } from 'ol/proj';
import XGeoJSON from '../format/XGeoJSON';

export function addOption(options, option, value) {

    if (value != null) {
        value = typeof value == "string" ? value.trim() : value;
        options[option] = value;
    }
}

export function getResolutionForScale(scale, projectionId, center) {
    if (scale == null) {
        return null;
    }

    let units = getProjection(projectionId).getUnits();
    let dpi = 25.4 / 0.28;
    let mpu = METERS_PER_UNIT[units];
    let inchesPerMeter = 39.37;
    let resolution = scale / (mpu * inchesPerMeter * dpi);

    return resolution;
}

export function getScaleForResolution(resolution, projectionId, center) {
    if (resolution == null) {
        return null;
    }

    if (center) {
        resolution = parseFloat(getPointResolution(getProjection(projectionId), resolution, center).toString());
    }

    let units = getProjection(projectionId).getUnits();
    let default_dpi = 25.4 / 0.28;
    let mpu = METERS_PER_UNIT[units];
    let inchesPerMeter = 39.37;
    let scale = resolution * mpu * inchesPerMeter * default_dpi;

    return scale;
}

export function handleAnalysisLoader(layerSettings, map, rootUrl, source, selectionHandler, generalActionHandler) {
    const bbox = layerSettings.LoadingStrategy != "allStrategy";
    let loader = (extent, resolution, projection) => {
        let data = {
            geomFieldName: layerSettings.Entity.GeomField,
            pkFieldName: layerSettings.Entity.PkField,
            analyse: layerSettings.Entity,
            srs: map.getView().getProjection().getCode()
        }

        if (bbox) {
            data.bbox = extent.join(',') + ',' + map.getView().getProjection().getCode();
        }

        $.ajax({
            type: "POST",
            url: rootUrl + paths.ANALYSIS_URL,
            async: true,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(data),
            success: (result) => {
                if (!result.Error) {
                    var formatOptions = {};

                    formatOptions.layerId = layerSettings.Id;

                    formatOptions.selectionHandler = selectionHandler;
                    formatOptions.generalActionHandler = generalActionHandler;
                    formatOptions.layerSettings = layerSettings;

                    if (layerSettings.Entity.GeomField != null && layerSettings.Entity.GeomField != '') {
                        formatOptions.geometryName = layerSettings.Entity.GeomField;
                    }

                    var geoJsonFormat = new XGeoJSON(formatOptions);
                    let features = geoJsonFormat.readFeatures(result, {
                        extent: extent,
                        featureProjection: projection
                    });

                    source.addFeatures(features);
                }
            },
            error: (e) => {

            }
        });
    }

    return loader;
}

export function handleNativeUrl(mapId, layerSettings, map, rootUrl) {
    const bbox = layerSettings.LoadingStrategy != "allStrategy";

    if (layerSettings.url == null) {
        layerSettings.url = rootUrl + paths.MAP_GET_FEATURE_URL + '?layer=' + layerSettings.Id;
    }

    let urlFunction = (extent) => {
        let url = layerSettings.url;
        url += '&srs=' + map.getView().getProjection().getCode();

        if (bbox) {
            url += '&bbox=' + extent.join(',') + ',' + map.getView().getProjection().getCode();
        }

        if (layerSettings.Filters) {
            url += '&filter=' + JSON.stringify(layerSettings.Filters);
        }        
        url += '&idMap=' + mapId;
        return url;
    };

    return urlFunction;
}

export function handleGeoserverVectorTileLayerUrl(mapId, rootUrl, layerSettings, map, gisSettingsHandler) {
    var url = rootUrl + paths.PROXY_URL + mapId + '/' + layerSettings.Fid.replaceAll('-', '') + gisSettingsHandler.settings.VectorTile_URL.replaceAll("{Workspace}", gisSettingsHandler.settings.Workspace);
    url = url.replaceAll("{Layer}", defaults.ENTITY_TYPE_NAME_PREFIX + layerSettings.Id);
    url = url.replaceAll("{Projection}", map.getView().getProjection().getCode());
    var format = "application/vnd.mapbox-vector-tile";
    var _format = layerSettings.Format == null ? gisSettingsHandler.settings.VectorTile_Format : layerSettings.Format;
    switch (_format) {
        case "application/vnd.mapbox-vector-tile":
            format = "application/vnd.mapbox-vector-tile";
            break;
        case "application/json;type=geojson":
            format = "application/json;type=geojson";
            break;
        case "application/json;type=topojson":
            format = "application/json;type=topojson";
            break;
    }
    url = url.replace("{Format}", format);

    return url;
}

export function handleWfsUrl(mapId, rootUrl, layerSettings, map, gisSettingsHandler) {
    const path = rootUrl + paths.PROXY_URL + mapId + '/' + layerSettings.Fid.replaceAll('-', '') + gisSettingsHandler.settings.Wfs_URL.replaceAll("{Workspace}", gisSettingsHandler.settings.Workspace);
    const version = gisSettingsHandler.settings.Wfs_Version;
    const typeName = gisSettingsHandler.settings.Workspace + ':' + defaults.ENTITY_TYPE_NAME_PREFIX + layerSettings.Id;
    const outputFormat = layerSettings.Format == null ? gisSettingsHandler.settings.Wfs_DefaultFormat : layerSettings.Format;
    const projectionName = layerSettings.Entity.GeometrySrid;
    const bbox = layerSettings.LoadingStrategy != "allStrategy";

    let urlFunction = (extent) => {
        let url = path + '?service=WFS&request=GetFeature&version=' + version + '&typeName=' + typeName
            + '&outputFormat=' + outputFormat + '&srsname=' + projectionName;

        var _filters = "";

        if (layerSettings.WfsFilters) {
            for (var i = 0; i < layerSettings.WfsFilters.length; i++) {

                var _currentFilter = "";
                for (var j = 0; j < layerSettings.WfsFilters[i].vals.length; j++) {
                    if (_currentFilter != "") {
                        _currentFilter += " OR ";
                    }
                    _currentFilter += layerSettings.WfsFilters[i].field + " " + layerSettings.WfsFilters[i].op + " " + layerSettings.WfsFilters[i].vals[j].toString();
                }

                if (_filters != "") {
                    _filters += " AND ";
                }
                _filters += "(" + _currentFilter.trim() + ")";
            }
        }

        if (_filters != null && _filters != "") {

            if (bbox && extent.length > 0) {
                url += '&CQL_FILTER= BBOX(' + layerSettings.Entity.GeometryFieldName + ',' + extent.join(',') + ") and (" + _filters + ")";
            }
            else {
                url += "&CQL_FILTER=" + _filters;
            }
        }
        else if (bbox && extent != null && extent.length > 0) {
            if (map.getView().getProjection().getCode() != projectionName) {
                extent = transformExtent(extent, map.getView().getProjection().getCode(), projectionName);
            }

            url += '&bbox=' + extent.join(',') + ',' + projectionName;
        }

        return url;
    };

    return urlFunction;
}

export function handleGeoserviceGeojsonWfsUrl(mapId, rootUrl, layerSettings, map) {
    let path;

    if (layerSettings.Geoservice.RequestUrl.indexOf('http') == 0) {
        path = layerSettings.Geoservice.RequestUrl;
    } else if (layerSettings.Geoservice.gsproxy) {
        path = rootUrl + paths.GSPROXY_URL + mapId + '/' + layerSettings.Geoservice.Id + layerSettings.Geoservice.RequestUrl.replaceAll("?request=GetFeature", '');
    } else {
        path = rootUrl + paths.PROXY_URL + mapId + '/' + layerSettings.Fid.replaceAll('-', '') + layerSettings.Geoservice.RequestUrl.replaceAll("?request=GetFeature", '');
    }

    let urlFunction = (extent) => {
        return path;
    };

    return urlFunction;
}

export function handleGeoserviceWfsUrl(mapId, rootUrl, layerSettings, map) {
    let path;

    if (layerSettings.Geoservice.RequestUrl.indexOf('http') == 0) {
        path = layerSettings.Geoservice.RequestUrl;
    } else if (layerSettings.Geoservice.gsproxy) {
        path = rootUrl + paths.GSPROXY_URL + mapId + '/' + layerSettings.Geoservice.Id + layerSettings.Geoservice.RequestUrl.replaceAll("?request=GetFeature", '');
    } else {
        path = rootUrl + paths.PROXY_URL + mapId + '/' + layerSettings.Fid.replaceAll('-', '') + layerSettings.Geoservice.RequestUrl.replaceAll("?request=GetFeature", '');
    }
    
    const version = layerSettings.Geoservice.Version != null ? layerSettings.Geoservice.Version : defaults.WFS_VERSION;
    const typeName = layerSettings.Geoservice.LayerName;
    const outputFormat = layerSettings.Format == null ? formats.DEFAULT_WFS_FORMAT : layerSettings.Format;
    const projectionName = layerSettings.Geoservice.TileMatrix;
    const bbox = layerSettings.LoadingStrategy != "allStrategy" && layerSettings.Geoservice.ServiceType != 'GEOJSON';

    let urlFunction = (extent) => {
        let url = path + '?service=WFS&request=GetFeature&version=' + version + '&typeName=' + typeName
            + '&outputFormat=' + outputFormat + '&srsname=' + projectionName;

        if (bbox) {
            if (map.getView().getProjection().getCode() != projectionName) {
                extent = transformExtent(extent, map.getView().getProjection().getCode(), projectionName);
            }

            url += '&bbox=' + extent.join(',') + ',' + projectionName;
        }
        return url;
    };

    return urlFunction;
}

export function isDesktop() {
    const userAgent = window.navigator.userAgent;
    const platform = window.navigator.platform;
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']

    if (/Android/.test(userAgent)) {
        return false;
    }

    if (iosPlatforms.indexOf(platform) !== -1) {
        return false;
    }

    return true;
}